let mapboxgl = window.mapboxgl;
import { EventSourcePolyfill } from 'event-source-polyfill'; //https://github.com/Yaffle/EventSource
import { db } from '../../main'

// const EventSource = EventSourcePolyfill;
// let demoDashes = ["sunsets"]

export default {
  name: 'Dashboard',
  data: function () {
    return {
      view: {
        fullscreen: false,
        loading: true,
        liveConnection: false,
        showDash: false,
        dashSettings: false,
        dashSettingsView: "data",
        canPanToPoint: true,
        tokenRegenLoading: false,
        shouldHaveLiveConnection: false
      },
      dashboard: null,
      heatmapData: null,
      eventTimeline: [],
      visibilitychange: null,
      mapOptions: {
        container: 'dashboardMap',
        style: 'mapbox://styles/mapbox/dark-v9',
        center: [0, 11],
        zoom: 2,
        minZoom: 1.5
      },
      mapStyles: [],
      eventStream: null,
      authToken: "12345678910abcdefghijklmnop",
      map: null,
      testCount: 0,
      demoEvent: {
        "title": "🔥🔥🔥Livedata Created",
        "description": "Dublin, Ireland",
        "location": {
          "lat": -6.2603,
          "lon": 53.3498
        }
      },
      pointsToRender: [],
      publicSpreadsheetUrl: null
    }
  },
  computed: {
    userOwnsDash() {
      return this.user && this.user.uid === this.dashboard.owner
    },
    user() {
      return this.$store.getters.userData
    },
    userAuth() {
      return this.$store.getters.userAuth
    },
    authChecked() {
      return this.$store.getters.authChecked
    },
    postUrl() {
      if (this.dashboard.name) {
        return "https://livedata.ninja/api/data/" + this.dashboard.name
      } else {
        return "loading..."
      }
    }
  },
  mounted: async function () {
  
    // populate map styles to choose from
    this.mapStyles = [
      { 
        "id": 1,
        "name": "Light Grey",
        "url": "mapbox://styles/chipd/cjvckrf590dcr1fkq876thply",
        "imageUrl": "/mapimages/lightgrey.png"
      },
      { 
        "id": 2,
        "name": "Decimal",
        "url": "mapbox://styles/chipd/cjuhdj6or2sup1fsih3jo64qy",
        "imageUrl": "/mapimages/decimal.png"
      },
      { 
        "id": 3,
        "name": "Light",
        "url": "mapbox://styles/chipd/ck1pej2tc21e91cptzwj7hr2e",
        "imageUrl": "/mapimages/light.png"
      },
      { 
        "id": 4,
        "name": "Monochrome",
        "url": "mapbox://styles/chipd/cjwb743om0ndg1cqkb2vmu3vf",
        "imageUrl": "/mapimages/monochrome.png"
      },
      { 
        "id": 5,
        "name": "Bubble",
        "url": "mapbox://styles/chipd/ck0pqb4pg0sl81cp200r1hhsn",
        "imageUrl": "/mapimages/bubble.png"
      },
      { 
        "id": 6,
        "name": "Cali Terrain",
        "url": "mapbox://styles/chipd/cjwhs83cu02ym1clevrcddnd7",
        "imageUrl": "/mapimages/caliterrain.png"
      }
    ]

    // Code for handling fullscreen shiz
    if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
      this.visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      this.visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      this.visibilityChange = "webkitvisibilitychange";
    }

    this.loadDocumentData()


    // handle if page is unfocused and re-focused
    document.addEventListener(this.visibilityChange, this.handlePageVisibilityChange);

  },
  beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // remove listener for visibility
    document.removeEventListener(this.visibilityChange, this.handlePageVisibilityChange)

    // remove the event stream if it exists
    console.log("removing eventStream")
    if (this.eventStream) {
      this.eventStream.close();
      this.eventStream = null;
    }
    next()
  },
  methods: {
    async loadDocumentData () {
      // get dashboard data
      this.dashboard = await this.getDashboardData()
      console.log('this.dashboard:', this.dashboard);

      // If no permissions or dashboard doesn't exist
      if(!this.dashboard) {
        this.view.showDash = false 
        this.view.loading = false
        return
      }

      // we can show the dashboard
      this.view.showDash = true
      this.view.loading = false

      // need to handle when the dashboard is listening to a twitter stream
      // this.startListening()
      // handle data sources
      if(this.dashboard.config.dataSources.length > 0){
        // loop over the data sources and handle them
        this.dashboard.config.dataSources.forEach(async source => {
          // console.log('looping source:', source)
          if(source.type === "googleSheet"){
            this.publicSpreadsheetUrl = source.url;
            try {
              let spreadsheetJSON = await this.getGoogleData(source.url);
              this.loopStaticEvents(spreadsheetJSON.data);
              await this.createHeatmapData(spreadsheetJSON.data);
            } catch(e) {
              console.log('error GOOGLE data:', e)
            }
          }
        });

      } else {
        console.log("No Data Sources configured for this dashboard")
      }

      // render the map if it's active
      if(this.dashboard.config.map.active){
        await this.renderMap()
        if(this.dashboard.config.map.heatmap){
          // await this.getHeatmapData();
          this.renderHeatmap()
        }
      }
    },
    async setGoogleSheetSource() {
      console.log('save Google sheet URL:', this.publicSpreadsheetUrl);

      // find the item in the sources array that's the Google spreadsheet one
      // set the publicSpreadSheetURL on it
      // save it

      let googleSource = this.dashboard.config.dataSources.filter(source => source.type === "googleSheet")[0]

      // handle if there's no googleSource
      if(!googleSource) {
        this.dashboard.config.dataSources.push(
          {
            url: this.publicSpreadsheetUrl,
            type: "googleSheet"
          }
        )
      } else {
        googleSource.url = this.publicSpreadsheetUrl;
      }


      try {
        await db.collection("dashboards").doc(this.dashboard.name).update(
          {"config": this.dashboard.config}
        )
        console.log("document saved")
        this.loadDocumentData()
      } catch(e) {
        console.log("error saving demo mode:", e)
      }
    },
    async acivateDemoMode () {
      
      console.log("activating demo mode")
      
      this.publicSpreadsheetUrl = "https://docs.google.com/spreadsheets/d/1acQ0cYWnhUa1_pKWpb745XGTOnPkHGvkRTdUEifkfZE/edit?usp=sharing";
      
      this.dashboard.config.map.heatmap = true
      this.dashboard.config.map.sidePanel = true

      this.setGoogleSheetSource()
    },
    async archiveDash(){
      // add archived field on dashboard, boolean
      // remove dashboard from dashboards array on user doc
      // return user to /account
      try {

        // Get a new write batch
        let batch = db.batch();

        let dashRef = db.collection("dashboards").doc(this.dashboard.name)
        batch.update(dashRef, {"archived": true} )

        let userRef = db.collection("users").doc(this.user.id)
        // filter out user.dashboards for this.dashboard.name
        let newDashArray = this.user.dashboards.filter(el => el !== this.dashboard.name);
        console.log('newDashArray:', newDashArray)
        batch.update(userRef, {"dashboards": newDashArray} )

        // Commit the batch
        await batch.commit()

        alert("dashboard archived successfully")
        // we need to re-get the user's data in the store
        await this.$store.dispatch("refreshUserData", this.user.id)
        this.$router.push('/account')
      } catch(e){
        console.log('error archiving dashboard:', e)
        alert(`error archiving dashboard: ${e}`)
      }
    },
    async createHeatmapData(data){
      return new Promise((resolve, reject)=>{
        try {
          // console.log("generating heatmap data from spreadsheet source:", data)
          let Features = data.map(event => {
            return {
              geometry: {
                coordinates: [event.longitude, event.latitude],
                type: "Point"
              },
              properties: {
                description: event.description,
                title: event.title
              },
              type: "Feature"
            }
          })
          this.heatmapData = {
            "type": "FeatureCollection",
            "features": Features
          }
          resolve()
        } catch(e){
          console.log('error creating heatmap data from Google sheet')
          reject(e)
        }
      })
    },
    loopStaticEvents(events){
      // console.log('looping static events:', events)
      // loop over each event, with a random delay after each one between
      // 0.5s and 5s
      events.forEach((event, i) => {
        event.location = {
          lat: event.latitude,
          lon: event.longitude
        }
        setTimeout(() => {
          this.addPoint(event);
        }, i * Math.floor(Math.random() * (10000 - 4000) + 4000));
      });

    },
    async getGoogleData(url) {
      return await new Promise((resolve, reject) => {
        const spreadSheet = url
        window.Tabletop.init({
          key: spreadSheet,
          callback: (data, tabletop) => { resolve({data, tabletop}) },
          error: (e) => {reject(e)},
          simpleSheet: true
        })
      })
    },
    eventOpacity(index) {
      // if it's 0 = 1
      // 1 = 0.75
      let opacity
      switch (index) {
        case 0:
          opacity = 1
          break;
        case 1:
          opacity = 0.5
          break
        case 2:
          opacity = 0.25
          break
        default:
          opacity = 0
          break;
      }
      // console.log("returning opacity:", opacity)
      return opacity
    },
    async getDashboardData(){
      // get the relevant dashboard from the DB
      // will contain tokens, configs etc
      try {
        let doc = await db.collection("dashboards").doc(this.$route.params.dashboard).get()
        // console.log('doc.data():', doc.data());
        let data = doc.data()
        data.name = doc.id
        return data;
      } catch(e){
        console.log("error getting dashboard:", e)
        // alert('error getting dashboard:', e)
        return
      }
    },
    async getHeatmapData(){
      console.log('getting heatmap data for:', this.$route.params.dashboard)
      // get the heatmap data from the db
      try {
        let heatmapDoc = await db.collection("heatmaps").doc(this.$route.params.dashboard).get()
        this.heatmapData = {
          "type": "FeatureCollection",
          "features": heatmapDoc.data()['features']
        }
        console.log('this.heatmapData:', this.heatmapData);
        
      } catch (e) {
       console.log("error getting heatmap:", e)
      //  alert('error getting heatmap:', e) 
      }
    },
    async renderHeatmap() {
      
      if(!this.dashboard.config.map.heatmap) return;
      console.log('rendering heatmap')
      
      if (this.map.getLayer('heatmapData')) {
        this.map.removeLayer('heatmapData');
        this.map.removeSource('heatmapData');
      }

      // get the heatmap data if we don't have it
      if(!this.heatmapData){
        await this.getHeatmapData()
      }
      
      this.map.addSource('heatmapData', {
        'type': 'geojson',
        'data': this.heatmapData
      });

      this.map.addLayer(
        {
          'id': 'heatmapData',
          'type': 'heatmap',
          'source': 'heatmapData',
          'maxzoom': 9,
          'paint': {
            // Increase the heatmap weight based on frequency and property magnitude
            'heatmap-weight': [
              'interpolate',
              ['linear'],
              ['get', 'mag'],
              0,
              0,
              6,
              1
            ],
            // Increase the heatmap color weight weight by zoom level
            // heatmap-intensity is a multiplier on top of heatmap-weight
            'heatmap-intensity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0,
              1,
              9,
              3
            ],
            // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
            // Begin color ramp at 0-stop with a 0-transparancy color
            // to create a blur-like effect.
            'heatmap-color': [
              'interpolate',
              ['linear'],
              ['heatmap-density'],
              0,
              'rgba(33,102,172,0)',
              0.2,
              'rgb(103,169,207)',
              0.4,
              'rgb(209,229,240)',
              0.6,
              'rgb(253,219,199)',
              0.8,
              'rgb(239,138,98)',
              1,
              'rgb(178,24,43)'
            ],
            // Adjust the heatmap radius by zoom level
            'heatmap-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0,
              2,
              9,
              20
            ],
            // Transition from heatmap to circle layer by zoom level
            'heatmap-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              7,
              1,
              9,
              0
            ]
          }
        }
      );
    },
    handlePageVisibilityChange(event) {

      if (event.target.visibilityState === "visible") {
        console.log('page refocused, now visible:', new Date());

        if(!this.showDash) return

        // check for connection, if there is none, start listening
        if (!this.eventStream || this.eventStream.readyState !== 1) {
          this.startListening();
        }
      }
    },
    renderMap() {
      
      let selectedStyle = this.mapStyles.find(style => (style.id == this.dashboard.config.map.style))['url']

      // console.log('selectedStyle:', selectedStyle)
      return new Promise((resolve)=>{

        setTimeout(() => {
          mapboxgl.accessToken = 'pk.eyJ1IjoiY2hpcGQiLCJhIjoiYW9sdFN1RSJ9.QHenEiJf4rDhmD9GXctdYw';

          if(this.map) {this.map.remove()}
  
          this.map = new mapboxgl.Map({
            container: 'dashboardMap',
            style: selectedStyle || 'mapbox://styles/chipd/cjvckrf590dcr1fkq876thply',
            center: [0, 11],
            zoom: 2,
            minZoom: 1.5
          });
  
          this.map.on('load', () => {
            // this.renderHeatmap();
            resolve()
          })
        }, 200)
  
        if (document.addEventListener) {
          document.addEventListener('webkitfullscreenchange', this.exitHandler, false);
          document.addEventListener('mozfullscreenchange', this.exitHandler, false);
          document.addEventListener('fullscreenchange', this.exitHandler, false);
          document.addEventListener('MSFullscreenChange', this.exitHandler, false);
        }

      })
    },
    async useMapStyle(style) {
      console.log('user wants to use:', style);
      this.map.setStyle(style.url);

      // update document in DB if we have user
      if(this.userOwnsDash){
        try {
          await db.collection('dashboards').doc(this.dashboard.name).update({
            "config.map.style": style.id
          })
        } catch (error) {
          // alert(error)
          console.log('error saving map style:', error)
        }
      }

      this.renderHeatmap();

    },
    exitHandler() {
      if (document.webkitIsFullScreen === false) {
        this.view.fullscreen = false;
      }
      else if (document.mozFullScreen === false) {
        this.view.fullscreen = false;
      }
      else if (document.msFullscreenElement === false) {
        this.view.fullscreen = false;
      }
    },
    sendDemoEvent(e) {

      e.preventDefault();

      // console.log("sending demo event:", this.demoEvent);
      this.addPoint(this.demoEvent);

    },
    setDemoEvent(name) {

      if (name == "paris") {
        this.demoEvent = {
          "title": "New Order! $249",
          "description": "Paris, FR",
          "time": "12.03pm GMT",
          "location": {
            "lat": 2.3522,
            "lon": 48.8566
          }
        }
      }

      if (name == "milan") {
        this.demoEvent = {
          "title": "Subscription started! $249",
          "description": "Milan, IT",
          "time": "12.03pm GMT",
          "location": {
            "lat": 9.191383,
            "lon": 45.464211
          }
        }
      }

      if (name == "newyork") {
        this.demoEvent = {
          "title": "Sale! $75.99",
          "description": "Brooklyn, NY",
          "time": "12.04pm GMT",
          "location": {
            "lat": -74.0150374,
            "lon": 40.6452228
          }
        }
      }

      this.addPoint(this.demoEvent);
    },
    retryListening() {
      // used to attemmpt to re-establish the connection
      console.log('retrying listening')
      var retryInterval = setInterval(everySecond, 1000);

      let everySecond = () => {
        if(!this.view.liveConnection){
          this.startListening()
        } else {
          stopInterval()
        }
      }

      function stopInterval() {
        console.log('stopping interval...');
        
        clearInterval(retryInterval);
      }
    },
    startListening() {
          
      console.log('listening Starting')
          
      // only start a stream if we don't already have one..
      if (!this.eventStream || this.eventStream.readyState !== 1) {

        this.eventStream = new EventSourcePolyfill(`/api/data/events?dash=${this.dashboard.name}`, {
          headers: {
            'X-api-key': this.dashboard.token
          }
        });

        this.eventStream.onopen = () => {
          // handle newly opened connection
          console.log("stream connection opened");
          this.view.liveConnection = true
        }

        this.eventStream.onerror = (evt) => {
          console.log('error for event stream:', evt)
          this.view.liveConnection = false;
          this.retryListening();
        }

        this.eventStream.onmessage = (evt) => {
          let data = JSON.parse(evt.data)
          console.log('message data:', data);
          if (this.view.canPanToPoint) {
            // no points in 
            this.addPoint(data);
          } else {
            // there are already points, push this to the end
            this.pointsToRender.push(data);
            console.log(`added point to pointsToRender: ${this.pointsToRender.length} left`)
          }
        };
      } else {
        console.log("not adding eventStream, seems we already have one:", this.eventStream);
      }
    },
    toggleFullscreen() {

      let element = this.$refs.map

      if(this.view.fullscreen === true){
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        this.view.fullscreen = false
      } else {
        if (element.requestFullscreen)
          element.requestFullscreen();
        else if (element.mozRequestFullScreen)
          element.mozRequestFullScreen();
        else if (element.webkitRequestFullscreen)
          element.webkitRequestFullscreen();
        else if (element.msRequestFullscreen)
          element.msRequestFullscreen();
        
          this.view.fullscreen = true
      }

    },
    nextMapPoint() {
      // check the array of events and render the next one
      if (this.pointsToRender.length) {
        // we have something to add
        let point = this.pointsToRender.shift();
        this.addPoint(point)
      } else {
        // console.log('no more points, zoom out');
        this.map.flyTo({
          center: [0, 11],
          zoom: 1,
          speed: 1,
          curve: 1.5
        });
      }
    },
    clearPopup(popup) {
      setTimeout(() => {
        popup.remove();
        this.view.canPanToPoint = true;
        this.nextMapPoint()
      }, 7500)
    },
    addPoint(point) {

      // add point to list of events
      this.addEvent(point);
      
      // console.log("adding test point:",point)
      if(this.view.canPanToPoint){

        this.view.canPanToPoint = false;

        try {
          // fly to that point
          this.map.flyTo({
            center: {lon: point.location.lon, lat: point.location.lat},
            zoom: 7,
            speed: 1,
            curve: 1.5,
            offset: this.dashboard.config.map.sidePanel ? [150, 0] : [0,0]
          });
    
          let popupHtml = `
            <h1 class="text-lg">${point.title}</h1>
            <p class="text-sm text-gray-600">${point.description}</p>
          `
    
          var popup = new mapboxgl.Popup({ closeOnClick: false })
            .setLngLat({lon: point.location.lon, lat: point.location.lat})
            .setHTML(popupHtml)
            .addTo(this.map);
    
          // let element = this.$refs.marker.cloneNode(true)
    
          // let markerOptions = {
          //   element: element,
          //   anchor: 'center'
          // }
    
          // var marker = new mapboxgl.Marker(markerOptions)
    
          // marker
          //   .setLngLat({lon: point.location.lon, lat: point.location.lat})
          //   .addTo(this.map);
    
          this.clearPopup(popup);

        } catch(e){
          console.log('error flying to or rendering point:', e)
        }

      }

    },
    addEvent(event){
      // will add an event to the sidePanel
      event.id = (Math.random() * (900000 - 100000 + 1) ) << 0
      // console.log('adding event:', event);

      this.eventTimeline.unshift(event);

      // prune list
      // only keep a max of 20 items in the list at any one time
      this.eventTimeline = this.eventTimeline.slice(0,5)

    },
    async regenerateToken(){
      console.log("user wants a new token");
      this.view.tokenRegenLoading = true

      let postBody = {
        "dashname": this.dashboard.name
      }

      try {
        let response = await fetch('/api/generate-token', {
          method: 'PUT',
          body: JSON.stringify(postBody),
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-api-key': this.dashboard.token
          }
        })
        let data = await response.json()
        // console.log('token data:', data);
        this.dashboard.token = data.token

        // close eventstream and start listening again
        if (this.eventStream) {
          this.eventStream.close();
          this.eventStream = null;
        }
        this.startListening();
      } catch(e){
        console.log("error regenerating token:", e);
        alert(e)
      } finally {
        this.view.tokenRegenLoading = false;
      }
    },
    toggleMapSetting(config){
      // console.log('user toggled map config:', config);

      switch (config) {
        case "heatmap":
          // console.log('heatmap toggled')
          this.renderHeatmap()
          break;
        case "sidePanel":
          // don't need to do anything do we?
          break
        case "ticker":
          console.log('user toggled ticker')
          break
        default:
          break;
      }

      if(!this.userOwnsDash) return;
      // persist changes to DB
      try {
        db.collection("dashboards").doc(this.dashboard.name).update(
          {"config": this.dashboard.config}
        )
      } catch(e){
        console.log('error updating dash config:', e)
      }
    },
    addTickerItem(){
      console.log("user adding ticker item")
      this.dashboard.config.ticker.items.push("")
    },
    async saveTickerItems(){
      // console.log('saving ticker items:', this.dashboard.config.ticker.items)

      this.dashboard.config.ticker.items = this.dashboard.config.ticker.items.filter(item => item.length > 0)
      try {
        await db.collection("dashboards").doc(this.dashboard.name).update(
          {"config.ticker": this.dashboard.config.ticker}
        )
        console.log("ticker items saved")
      } catch(e) {
        console.log("error: saving ticker items failed:", e)
        alert(`Error saving ticker items: ${e}`)
      }
    }
  }
}